import { Avatar, Box, FormControl, Grid, IconButton, MenuItem, Select, TextField, Typography, Button, InputAdornment } from '@mui/material'
import { ArrowBack, Visibility, VisibilityOff } from '@mui/icons-material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import useHrManageFormController from "./controller/form"
import { ProvinceModel } from '../../models/province';
import { District } from '../../models/district';
import { GenderEnum } from '../../enums/genderEnum';
import { convertGenderToString } from '../../utils/convertGender';
import { RoleAndPermissionModel } from '../../models/roleAndPermission';
import ConfirmDialog from '../../components/ConfirmDialog';
import { EmployeeModel } from '../../models/employee';
import { useTranslation } from 'react-i18next';

interface Props {
    onClose: VoidFunction
    roleValue: RoleAndPermissionModel
    onFetchData: Function
    selectData: EmployeeModel
}

const FormHrManageView = ({ onClose, roleValue, onFetchData, selectData }: Props) => {
    const controller = useHrManageFormController({ onClose, roleValue, onFetchData, selectData })
    const { t } = useTranslation('global')

    return (
        <Box>
            <IconButton onClick={() => { onClose() }}>
                <ArrowBack />
            </IconButton>
            <Typography variant="h4" fontWeight='bold' color={TEXT_TITLE_COLOR}>{selectData ? t("Mr_manage.Edit HR") : t("Mr_manage.Create HR")}</Typography>
            <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box
                            sx={{
                                p: 8,
                                boxShadow:
                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                borderRadius: '10px'
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <label htmlFor="image-input-admin">
                                    <Avatar
                                        src={controller.imageToShow}
                                        alt=""
                                        style={{ cursor: 'pointer', width: 150, height: 150, objectFit: 'contain' }}
                                    />
                                </label>
                                <input
                                    type="file"
                                    id="image-input-admin"
                                    onClick={(e: any) => {
                                        e.target.value = '';
                                    }}
                                    onChange={controller.handleSelectedImage}
                                    style={{ display: 'none' }}
                                />
                            </Box>
                            <Box mt={2}>
                                <Typography textAlign="center">Allowed *.jpeg, *.jpg, *.png</Typography>
                                <Typography textAlign="center">Max size of 3.1 MB</Typography>
                            </Box>
                        </Box>
                        {/* {
                            selectedAdmin && <Box
                                sx={{ display: selectedAdmin?.id === adminId ? 'none' : 'flex', justifyContent: 'center', mt: 1, alignItems: 'center', gap: 2 }}
                            >
                                <Typography>
                                    <span style={{ color: 'green' }}>{t("admin_page.Active")}</span> / <span style={{ color: 'red' }}>{t("admin_page.InActive")}</span>
                                </Typography>
                                <SwitchComponent value={controller.banUser} onChange={controller.handleBanUser} />
                            </Box>
                        } */}

                    </Grid>
                    <Grid item xs={12} sm={10} md={8}>
                        <Box
                            sx={{
                                p: 4,
                                boxShadow:
                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                borderRadius: '10px'
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Full Name")}</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        margin="normal"
                                        inputRef={controller.fullName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Phone")}</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        margin="normal"
                                        inputRef={controller.phone}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Email")}</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        margin='normal'
                                        inputRef={controller.email}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Date of Birth")}</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        margin='normal'
                                        type='date'
                                        inputRef={controller.dateOfBirth}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Province")}</Typography>
                                    <FormControl fullWidth margin='normal'>
                                        <Select value={controller.provinceValue} onChange={controller.handleSelectedProvince}>
                                            {
                                                controller.provinceData?.map((data: ProvinceModel) => (
                                                    <MenuItem key={data?.id} value={data?.provinceNameLA}>
                                                        {data?.provinceNameLA}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.City")}</Typography>
                                    <FormControl fullWidth margin='normal'>
                                        <Select value={controller.districtsValue} onChange={controller.handleSelectedDistrict}>
                                            {
                                                controller.districtsData?.map((dis: District) => (
                                                    <MenuItem key={dis?.districtCode} value={dis?.districtNameLA}>
                                                        {dis?.districtNameLA}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Village")}</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        margin='normal'
                                        inputRef={controller.village}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Gender")}</Typography>
                                    <FormControl fullWidth margin='normal'>
                                        <Select value={controller.selectedGender} onChange={controller.handleSelectedGender}>
                                            {
                                                Object.values(GenderEnum).map((gender: GenderEnum) => (
                                                    <MenuItem key={gender} value={gender}>
                                                        {convertGenderToString(gender)}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.username")}</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        margin='normal'
                                        inputRef={controller?.userName}
                                        disabled={selectData ? true : undefined}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography>{t("Mr_manage.Role")}</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        margin='normal'
                                        value={roleValue?.name}
                                        disabled
                                    />
                                </Grid>

                                {
                                    selectData ? <Box>

                                    </Box> :
                                        <>
                                            <Grid item xs={12} sm={6}>
                                                <Typography>{t("Mr_manage.Password")}</Typography>
                                                <TextField
                                                    type={controller.showPassword ? 'text' : 'password'}
                                                    fullWidth
                                                    required
                                                    margin='normal'
                                                    inputRef={controller.password}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position='end'>
                                                                <IconButton
                                                                    edge="end"
                                                                    onClick={controller.handleShowPassword}
                                                                    onMouseDown={(e) => e.preventDefault()}
                                                                >
                                                                    {controller.showPassword ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Typography>{t("Mr_manage.Confirm Password")}</Typography>
                                                <TextField
                                                    type={controller.showConfirmPassword ? 'text' : 'password'}
                                                    fullWidth
                                                    required
                                                    margin='normal'
                                                    inputRef={controller.confirmPassword}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position='end'>
                                                                <IconButton
                                                                    edge="end"
                                                                    onClick={controller.handleShowConfirmPassword}
                                                                    onMouseDown={(e) => e.preventDefault()}
                                                                >
                                                                    {controller.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </Grid>
                                        </>
                                }

                            </Grid>
                            {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
                            <Box mt={3} sx={{ display: 'flex', gap: 1, justifyContent: 'end' }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color='secondary'
                                    sx={{ textTransform: 'none', width: 100, color: '#fff' }}
                                >
                                    {t(`${selectData ? 'Edit' : 'Create'}`)}
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <ConfirmDialog
                    open={controller.openConfirm}
                    title={t(`Do you want to ${selectData ? "edit" : "create"} this HR`)}
                    loading={controller.loadingConfirmForm}
                    onCancel={controller.handleCloseConfirmForm}
                    onConfirm={() => controller.handleSubmit()}
                />
            </form>
        </Box>
    )
}

export default FormHrManageView